export const translations = {
  en: {
    landing: {
      hero_title: "TaleMatrix",
      hero_subtitle: "Your AI-Powered RPG Game Master",
      hero_description: "Embark on epic adventures with AI-driven storytelling. Create characters, explore worlds, and experience D&D-inspired campaigns.",
      cta_start: "Enter The Matrix",
      feature_1_title: "AI Game Master",
      feature_1_desc: "Multiple AI models power your adventures",
      feature_2_title: "Character Creation",
      feature_2_desc: "Create unique characters with AI portraits",
      feature_3_title: "Infinite Adventures",
      feature_3_desc: "Every story adapts to your choices",
    },
    auth: {
      sign_in_google: "Sign in with Google",
      welcome_back: "Welcome back, adventurer",
    },
    character: {
      create: "Create Character",
      name: "Name",
      race: "Race",
      class: "Class",
      backstory: "Backstory",
      generate_portrait: "Generate AI Portrait",
      image_model: "Image Model",
      start_adventure: "Start Adventure",
    },
    game: {
      your_message: "Your message...",
      send: "Send",
      model_select: "Select AI Model",
      new_campaign: "New Campaign",
    },
    settings: {
      title: "Settings",
      language: "Language",
      preferred_model: "Preferred AI Model",
      logout: "Logout",
    },
  },
  zh: {
    landing: {
      hero_title: "TaleMatrix",
      hero_subtitle: "您的AI驱动RPG游戏主持人",
      hero_description: "通过AI驱动的叙事踏上史诗般的冒险。创建角色,探索世界,体验D&D灵感的战役。",
      cta_start: "进入矩阵",
      feature_1_title: "AI游戏主持人",
      feature_1_desc: "多个AI模型为您的冒险提供动力",
      feature_2_title: "角色创建",
      feature_2_desc: "使用AI肖像创建独特角色",
      feature_3_title: "无限冒险",
      feature_3_desc: "每个故事都会适应您的选择",
    },
    auth: {
      sign_in_google: "使用Google登录",
      welcome_back: "欢迎回来,冒险家",
    },
    character: {
      create: "创建角色",
      name: "名字",
      race: "种族",
      class: "职业",
      backstory: "背景故事",
      generate_portrait: "生成AI肖像",
      image_model: "图像模型",
      start_adventure: "开始冒险",
    },
    game: {
      your_message: "您的消息...",
      send: "发送",
      model_select: "选择AI模型",
      new_campaign: "新战役",
    },
    settings: {
      title: "设置",
      language: "语言",
      preferred_model: "首选AI模型",
      logout: "登出",
    },
  },
  ru: {
    landing: {
      hero_title: "TaleMatrix",
      hero_subtitle: "Ваш игровой мастер с ИИ",
      hero_description: "Отправляйтесь в эпические приключения с повествованием на основе ИИ. Создавайте персонажей, исследуйте миры и участвуйте в кампаниях в стиле D&D.",
      cta_start: "Войти в Матрицу",
      feature_1_title: "ИИ Игровой Мастер",
      feature_1_desc: "Несколько моделей ИИ управляют вашими приключениями",
      feature_2_title: "Создание персонажа",
      feature_2_desc: "Создавайте уникальных персонажей с портретами ИИ",
      feature_3_title: "Бесконечные приключения",
      feature_3_desc: "Каждая история адаптируется к вашему выбору",
    },
    auth: {
      sign_in_google: "Войти через Google",
      welcome_back: "С возвращением, искатель приключений",
    },
    character: {
      create: "Создать персонажа",
      name: "Имя",
      race: "Раса",
      class: "Класс",
      backstory: "Предыстория",
      generate_portrait: "Создать портрет ИИ",
      image_model: "Модель изображения",
      start_adventure: "Начать приключение",
    },
    game: {
      your_message: "Ваше сообщение...",
      send: "Отправить",
      model_select: "Выбрать модель ИИ",
      new_campaign: "Новая кампания",
    },
    settings: {
      title: "Настройки",
      language: "Язык",
      preferred_model: "Предпочитаемая модель ИИ",
      logout: "Выйти",
    },
  },
  de: {
    landing: {
      hero_title: "TaleMatrix",
      hero_subtitle: "Ihr KI-gesteuerter RPG-Spielleiter",
      hero_description: "Begeben Sie sich auf epische Abenteuer mit KI-gesteuertem Storytelling. Erstellen Sie Charaktere, erkunden Sie Welten und erleben Sie D&D-inspirierte Kampagnen.",
      cta_start: "Matrix betreten",
      feature_1_title: "KI-Spielleiter",
      feature_1_desc: "Mehrere KI-Modelle treiben Ihre Abenteuer an",
      feature_2_title: "Charaktererstellung",
      feature_2_desc: "Erstellen Sie einzigartige Charaktere mit KI-Porträts",
      feature_3_title: "Unendliche Abenteuer",
      feature_3_desc: "Jede Geschichte passt sich Ihren Entscheidungen an",
    },
    auth: {
      sign_in_google: "Mit Google anmelden",
      welcome_back: "Willkommen zurück, Abenteurer",
    },
    character: {
      create: "Charakter erstellen",
      name: "Name",
      race: "Rasse",
      class: "Klasse",
      backstory: "Hintergrundgeschichte",
      generate_portrait: "KI-Porträt generieren",
      image_model: "Bildmodell",
      start_adventure: "Abenteuer starten",
    },
    game: {
      your_message: "Ihre Nachricht...",
      send: "Senden",
      model_select: "KI-Modell auswählen",
      new_campaign: "Neue Kampagne",
    },
    settings: {
      title: "Einstellungen",
      language: "Sprache",
      preferred_model: "Bevorzugtes KI-Modell",
      logout: "Abmelden",
    },
  },
};
